import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Standort auswählen',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Tischbestellung',
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
  },
  text_inputs: {
    address: {
      placeholder: 'Suche nach deiner Adresse',
    },
    street_name: {
      placeholder: 'Straße',
    },
    street_number: {
      placeholder: 'Str-Nummer',
    },
    city: {
      placeholder: 'Stadt',
    },
    zip: {
      placeholder: 'PLZ',
    },
  },

  time_options: {
    asap: {
      title: 'Standard',
      description: 'Fertig in {{time}} min',
    },
    scheduled: {
      title: 'Planen für später',
    },
  },

  time_drop_down: {
    today: 'Heute',
  },

  pickup: {
    address: 'Abholadresse',
    when: 'Wann soll die Bestellung bereit sein?',
  },

  delivery: {
    where: 'Wohin?',
    when: 'Wann soll die Bestellung bereit sein?',
    address: 'Deine Adresse',
    delivery_area: 'Unser Lieferradius',
  },

  buttons: {
    view_menu: 'Menü anzeigen',
    see_hours: 'Öffnungszeiten anzeigen',
    next: 'Weiter',
    change: 'Ändern',
    save: 'Speichern',
  },

  labels: {
    when: 'Wann?',
    pickup: 'Online Abholung',
    delivery: 'Lieferung',
    pickup_time: 'Abholzeitpunkt',
    delivery_time: 'Lieferzeitpunkt',
    discount: 'Nur hier mit {{value}} Online Rabatt',
    pre_orders_enabled: 'Aktuell kannst du eine Bestellung für später machen',
    change_location: '← Zurück zum Menü, wenn du einen anderen Standort bevorzugst',
    return: 'Zurück',
  },

  items_dropped: {
    count_one: '{{count}} Artikel entfernt',
    count_other: '{{count}} Artikel entfernt',
    pickup_reason: '— nicht für Abholung verfügbar.',
    delivery_reason: '— nicht für Lieferung verfügbar.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Leider konnten wir diese Adresse nicht finden. Bitte versuche es erneut, indem du zuerst die Straße im Suchfeld eingibst.',
    [ValidationErrors.address_not_serviceable]:
      'Deine Adresse liegt außerhalb unserer Lieferzone. Möchtest du deine Adresse ändern oder auf Abholung umstellen? 😊',
    [ValidationErrors.no_drivers_available]:
      'Tut uns leid, wir können derzeit nicht liefern. Magst du zum Abholen bestellen? 😊',
    pickup_unavailable: 'Es tut uns leid, dass wir Moment keine Abholung anbieten.',
    delivery_unavailable: 'Es tut uns leid, dass wir im Moment keine Lieferung anbieten.',
    delivery_paused: 'Es tut uns leid, dass wir im Moment keine Lieferung anbieten.',
    outside_pickup_times: 'Wir bieten keine Abholung zu dieser Zeit an. Unsere Abholzeiten:',
    outside_delivery_times: 'Wir bieten keine Lieferung zu dieser Zeit an. Unsere Lieferzeiten:',
    orders_paused_inactivity:
      'Aufgrund der überwältigenden Anfrage können wir derzeit keine weiteren Online-Bestellungen annehmen. Bitte bestelle vor Ort oder versuche es hier erneut in 30 Minuten erneut.',
    orders_paused_manual_end_of_day: 'Tut uns leid, wir sind für den Rest des Tages geschlossen.',
    orders_paused_manual_until_time:
      'Aufgrund der überwältigenden Anfrage können wir derzeit keine weiteren Online-Bestellungen annehmen. Bitte bestelle vor Ort oder versuche es hier erneut um {{pausedUntil}}',
    company_closed: 'Leider sind wir zu dieser Uhrzeit geschlossen.',
    pickup_closed:
      'Wir nehmen Abholbestellungen bis {{time}} an, da unsere Vorbereitungszeit {{preparationTime}} Minuten beträgt.',
    delivery_closed:
      'Wir nehmen Lieferbestellungen bis {{time}} an, da unsere Lieferzeit {{preparationTime}} Minuten beträgt.',
    live_orders_off:
      'Es tut uns leid, wir können derzeit keine weiteren Online-Bestellungen annehmen. Wir danken für dein Verständnis.',
    orders_unavailable: '{{type}} ist zur Zeit nicht möglich. Der nächstmogliche {{typeTime}} ist {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Entschuldigung, aktuell sind keine Fahrer verfügbar. Bitte versuche es später erneut oder bestelle zur Abholung und nutze den Promo-Code <PromoCode>{{code}}</PromoCode> beim Checkout.',
    without_code:
      'Entschuldigung, aktuell sind keine Fahrer verfügbar. Bitte versuche es später erneut oder bestelle zur Abholung.',
    copied: 'Promo-Code kopiert',
  },
};
